import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import GoogleMapComponent from "../google-map-component";

const mapContainerStyle = {
  width: "100%",
  height: "500px",
};

function ModalMap(props) {
  return (
    <Modal
      show={props.open}
      onHide={() => props.onClose(false)}
      keyboard={false}
      size="lg"
      centered
      className="map-view-modal-style"
    >
      <Modal.Body>
        <GoogleMapComponent
          days={props.days}
          mapContainerStyle={{
            width: "100%",
            height: "500px",
          }}
        />
      </Modal.Body>
    </Modal>
  );
}

export default React.memo(ModalMap);
